import Paper from '@/components/Paper'
import { FilterBar } from '@/components/ui/data-table-customized/filter-bar/filter-bar'
import type { FilterItemConfig } from '@/components/ui/data-table-customized'
import { DEPARTMENT_IDS } from '@/constants/departments'
import {
    getEmployeeContains,
    getEmployeesOptionsPaginated,
} from '@/modules/Employee/services'
import { useMemo } from 'react'
import { UseFormReturn } from 'react-hook-form'
import { CustomerPipelineFilters } from '../types'

const EMPLOYEE_DEPT_IDS = [
    DEPARTMENT_IDS.SALES,
    DEPARTMENT_IDS.ACCOUNT,
    DEPARTMENT_IDS.BOARD_OF_DIRECTORS,
]

const salePaginatedOptions = (query: string, page?: number) =>
    getEmployeesOptionsPaginated(query, EMPLOYEE_DEPT_IDS, 'active', page)

interface FiltersProps {
    control: UseFormReturn<CustomerPipelineFilters>['control']
    setValue: UseFormReturn<CustomerPipelineFilters>['setValue']
}

const Filters: React.FC<FiltersProps> = ({ control, setValue }) => {
    const setFilter = (key: keyof CustomerPipelineFilters, value: any) => {
        setValue(key, value)
    }

    const filterItems: FilterItemConfig[] = useMemo(
        () => [
            {
                name: 'sales_manager_codes',
                type: 'async-select' as const,
                label: 'Nhân viên kinh doanh',
                placeholder: 'Chọn nhân viên',
                asyncOptions: salePaginatedOptions,
                getDefaultOptions: (values: number[]) =>
                    getEmployeeContains({ employee_ids: values }),
                multiple: true,
                cols: 2,
            },
            {
                name: 'date_range',
                type: 'daterangepicker' as const,
                names: ['gte', 'lte'] as [string, string],
                label: 'Khoảng thời gian',
                showPresets: true,
                numberOfMonths: 2,
                cols: 2,
            },
        ],
        []
    )

    return (
        <Paper className="py-2">
            <FilterBar
                control={control}
                setFilter={setFilter}
                items={filterItems}
                hideSearch
                tourPrefix="sp-filter"
            />
        </Paper>
    )
}

export default Filters
